/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import SkeletonStyles from './SkeletonStyles';

const styles = (theme) => ({
    // Import Skeleton layout
    ...SkeletonStyles,

    // Page Elements
    root: {
        marginBottom: '16px',
        [theme.breakpoints.down(600)]: {
            padding: '0 16px',
        },
    },
    blockBody: {
        width: '100%',
        height: '86px',
        minHeight: '151px',
        [theme.breakpoints.down(600)]: {
            minHeight: '143px',
        },
    },
});

const SubscriptionSkeleton = ({ classes }) => (
    <div className={classes.root}>
        <div className={`${classes.blockBody} ${classes.block}`} />
    </div>
);
SubscriptionSkeleton.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(SubscriptionSkeleton);
